<template>
    <v-dialog :value="true" persistent max-width="600px" @click:outside="closeDialog()" v-bind="$attrs"
        :retain-focus="false" v-on="$listeners">
        <v-card>
            <v-card-title><span class="headline">Insertar material</span></v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete :loading="loading" :disabled="loading" :value="materialSelected"
                                @input="setMaterialSelected" :items="materialesList" chips color="blue-grey lighten-2"
                                label="Selecciona" return-object :item-text="item => item.no + ' - ' + item.description"
                                :item-value="item => item.no + ' - ' + item.description">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="materialSelected.qty" label="Unidades" type="number" min="0"
                                :disabled="materialSelected.no === null"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="materialSelected.unitPrice" label="Precio/u" type="number" min="0"
                                :disabled="materialSelected.no === null"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="materialSelected.discount" label="Descuento %" type="number" min="0"
                                :disabled="materialSelected.no === null"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeDialog">Cancelar</v-btn>
                <v-btn text :disabled="$v.materialSelected.$invalid" @click="handleSave" @keydown.ctrl="ctrlPulsado = true">
                    Añadir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import { required } from "vuelidate/lib/validators";
import uuidv4 from "../../mixins/uuidv4";

const greaterThanZero = (value) => value >= 0;
export default {
    name: 'MaterialNew',
    mixins: [uuidv4],
    data() {
        return {
            materialSelected: {
                no: null,
                description: null,
                qty: 0,
                discount: 0,
            },
        }
    },
    validations: {
        materialSelected: {
            no: { required },
            unitPrice: { greaterThanZero },
            discount: { min: 0 }
        },
    },
    methods: {
        closeDialog() {
            this.$emit("close")
        },
        handleSave() {
            this.$emit('saveItem', this.materialSelected)
            this.closeDialog()
        },
        setMaterialSelected(item) {
            this.materialSelected = {
                ...item,
                id: this.uuidv4(),
                qty: 1,
                discount: 0
            }
        }
    },
    computed: {
        ...mapGetters({
            materialesList: "materiales/materialesList",
            loading: "materiales/loadingList",
        }),
    },
    mounted() {
        this.$store.dispatch('materiales/getMateriales')
    },
}
</script>
